import type { TenantName } from '@root/@types/types';

import type { BrandingAJG, BrandingArtificial, BrandingBMS, BrandingHowden, BrandingLockton } from './types';

const client: TenantName = import.meta.env?.VITE_CLIENT ?? process?.env?.CLIENT;
if (!client) {
  throw new Error('Missing env var: CLIENT');
}

const getDefaultPdfBrandingAJG = () => {
  return 'Gallagher' satisfies BrandingAJG;
};

const getDefaultPdfBrandingBMS = () => {
  return 'BMS' satisfies BrandingBMS;
};

const getDefaultPdfBrandingHowden = () => {
  return 'Howden' satisfies BrandingHowden;
};

const getDefaultPdfBrandingLockton = () => {
  return 'Lockton' satisfies BrandingLockton;
};

const getDefaultPdfBrandingArtificial = () => {
  return 'Artificial' satisfies BrandingArtificial;
};

export const getDefaultPdfBranding = (): string =>
  client === 'ct-ajg'
    ? getDefaultPdfBrandingAJG()
    : client === 'ct-bms'
      ? getDefaultPdfBrandingBMS()
      : client === 'ct-howden'
        ? getDefaultPdfBrandingHowden()
        : client === 'ct-lockton'
          ? getDefaultPdfBrandingLockton()
          : getDefaultPdfBrandingArtificial();
